export default "__VITE_ASSET__BkwHqi3I__"